import { createFileRoute } from '@tanstack/react-router';
import { ArioDashboard } from '~portal/components/admin/automations/dashboard/ArioDashboard';

/**
 * @desc `/admin/ario` is the section's landing page, the Ario dashboard
 * (add-ario-identity-and-authoring-round-3 D18): recent files, runs, new workflows and
 * collectors, conversations and the next schedules. It used to redirect to Workflows. With
 * `VITE_AUTOMATIONS_ENABLED` off the parent route's guard makes the whole section not found, this
 * page included, so no redirect is needed for that case either.
 */
export const Route = createFileRoute('/_protected/admin/ario/')({
  component: ArioDashboard,
});
